import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCCION_GUIA_TYPES } from '../../../utils/produccionGuiaPaths';

const GuiasProduccionHub = () => (
  <div className="p-4 sm:p-6 max-w-4xl mx-auto">
    <nav className="text-sm text-gray-600 mb-4">
      <Link to="/dashboard" className="hover:text-teal-600">
        Dashboard
      </Link>
      <span className="mx-2">/</span>
      <Link to="/produccion" className="hover:text-teal-600">
        Producción
      </Link>
      <span className="mx-2">/</span>
      <span className="text-gray-800">Guías de producción</span>
    </nav>

    <h1 className="text-2xl font-bold text-gray-800 mb-2">Guías de producción</h1>
    <p className="text-gray-600 text-sm mb-8">
      Registre las cantidades elaboradas por receta. Elija el tipo de guía según la salida de las recetas (terminado o
      en proceso); el formulario lista todas las recetas correspondientes para que solo ingrese los números.
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {Object.values(PRODUCCION_GUIA_TYPES).map((cfg) => (
        <Link
          key={cfg.slug}
          to={`/produccion/guias/${cfg.slug}`}
          className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
        >
          <span className="text-2xl" aria-hidden>
            {cfg.guideType === 'producto_terminado' ? '✅' : '⚗️'}
          </span>
          <h2 className="mt-2 font-medium text-gray-900">{cfg.title}</h2>
          <p className="text-sm text-gray-500 mt-1">{cfg.description}</p>
        </Link>
      ))}
    </div>
  </div>
);

export default GuiasProduccionHub;
